























import Vue from 'vue'

export default Vue.extend({
  name: 'TextareaInput',
  props: {
    name: {},
    value: String,
    placeholder: {},
    suffixIcon: {},
    readOnly: {type: Boolean, default: false},
    required: {type: Boolean, default: false},
    type: String,
    rows: {
      type: Number,
      default: 3
    },
    error: Boolean
  },
  data () {
    return {
      focused: false
    }
  },
  methods: {
    onBlur (event: UIEvent) {
      this.$emit('blur', event)
      this.focused = false;
    },
    onInput (event: string) {
      this.$emit('input', event)
    },
    onFocus (event: UIEvent) {
      this.focused = true;
    }
  },
  computed: {
    currentValue: {
      get (): string {
        return this.value || ''
      },
      set () {
      }
    }
  }
})
